import React, { useMemo, } from 'react';
import TrendingPosts from '@op/pages/Overview/TrendingPublications/TrendingPosts';
import { JumpType } from '@home/utils/utils';
function OpinionsTrendPosts(props: any) {
  const { wholeGameInfo, gameInfo, language = 'origin', hasMore = true, filter, titleOnClickPath, extraParams, filterCond } = props;

  const params = useMemo(() => {
    if (!filter?.date_type || !filterCond) return {};
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    return { 
      ...(restFilter || {}),
      social_media_by_account: filterCond?.social_media_by_account || undefined,
      social_media_by_keyword: undefined,
      ...extraParams
    };
  }, [extraParams, filter, filterCond]);

  return (
    <TrendingPosts
      language={language}
      filter={params}
      wholeGameInfo={wholeGameInfo || gameInfo}
      hasMore={hasMore}
      gameInfo={gameInfo}
      titleOnClickPath={titleOnClickPath}
      jumpType={JumpType.Window}
    ></TrendingPosts>
  );
}

export default OpinionsTrendPosts;
